import { render, staticRenderFns } from "./TimestampBlok.vue?vue&type=template&id=7cdb28ce&"
import script from "./TimestampBlok.vue?vue&type=script&lang=js&"
export * from "./TimestampBlok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports